'use strict';

var AppState = require('app_state');
var Consts = require('consts');
var Misc = require('utils/misc');

var ValueView = Backbone.Marionette.ItemView.extend({
    inputData: {},
    template: require('components/devices/templates/tools/stats/value'),

    events: {
        'change select#valuespecs-sel': 'changeValue',
        'click #js-btn-add': 'onAdd',
    },

    ui: {
        ddlValueSpecs: 'select#valuespecs-sel',
    },

    initialize: function (options) {
        this.values = options.values;
        this.cb = options.cb;
        this.isEdit = options.item !== undefined;
        this.deviceList = options.deviceList;

        if (options.item) {
            this.inputData = _.clone(options.item);
        }
    },

    serializeData: function () {
        var data = Backbone.Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        data.inputData = this.inputData;
        data.values = this.values;

        if (this.deviceList && this.deviceList.models && this.deviceList.models.length) {
            var self = this;

            var foundInList = false;
            data.values = Misc.selectWhere(data.values, function (item) {
                if (item.id == self.inputData.value) return true;
                var itemFoundInList =
                    Misc.selectWhere(self.deviceList.models, function (m) {
                        return (m.get('data') || {})[item.id] !== undefined;
                    }).length > 0;
                foundInList = foundInList || itemFoundInList;
                return itemFoundInList;
            });

            if (!foundInList) data.values = this.values;
        }

        data.isEdit = this.isEdit;
        return data;
    },

    onShow: function () {
        Misc.initSelectPicker();
        this.updateData(true, !this.isEdit);
    },

    onRender: function () {
        Misc.initSelectPicker();
    },

    changeValue: function () {
        this.updateData(true, true);
    },

    updateData: function (doRender, useDefaultName) {
        var self = this;
        this.inputData.value = this.ui.ddlValueSpecs.val();
        if (!this.inputData.value) return;

        this.valueSpec = AppState.availableColumnData(this.inputData.value) || {};
        this.inputData.aggregation = this.inputData.aggregation || 'SUM';
        this.inputData.name = this.valueSpec.name;

        if (doRender) this.render();
    },

    onAdd: function () {
        this.updateData(false, false);
        var result = _.clone(this.inputData);
        if (this.cb) {
            this.cb(result);
        }
    },
});

module.exports = ValueView;
